<!-- <div class="merchant_detail_sec"  >
    <div class="mrt_offer">
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#b0b0b0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
      <h3>
        Coming soon
      </h3>
      <p>
        We are working day and night to bring all the latest features to you.
        Keep looking at this page, things are coming very soon.
      </p>
    </div>
  </div>  -->
  <!-- <sm-title-bar  pageTitle="Messages" >
   
  </sm-title-bar> -->

  <!-- <div mat-dialog-title class="d-flex justify-content-between align-items-center" style="margin: 0 0 10px !important;">
    <h2 class="m-0"></h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div> -->
  <mat-dialog-content style="max-height: fit-content;">
    <div class="chat-container" *ngIf="!loader">
        <!-- previously chatted -->
        <div class="right-panel" *ngIf="selectedThread.length > 0 && !chatLoader">
          <div class="header">
            <!-- <img *ngIf="myProfileHash == selectedThread[0].senderInfo.hash_id" [src]="selectedThread[0].receiverInfo.imgThumbUrl" onerror="this.src='../../../../assets/images/user-avatar.svg'" style="height: 50px; width: 50px; border-radius: 50%;" alt="">
            <img *ngIf="myProfileHash == selectedThread[0].receiverInfo.hash_id" [src]="selectedThread[0].senderInfo.imgThumbUrl" onerror="this.src='../../../../assets/images/user-avatar.svg'" style="height: 50px; width: 50px; border-radius: 50%;" alt="">
            <span style="margin-left: 10px;" *ngIf="myProfileHash == selectedThread[0].senderInfo.hash_id"> {{ selectedThread[0].receiverInfo.name }}</span>
            <span style="margin-left: 10px;" *ngIf="myProfileHash == selectedThread[0].receiverInfo.hash_id"> {{ selectedThread[0].senderInfo.name }}</span> -->

            <span *ngIf="(myProfileHash == selectedThread[0].senderInfo.hash_id && myProfileHash != selectedThread[0].receiverInfo.hash_id) || (myProfileHash != selectedThread[0].senderInfo.hash_id && myProfileHash == selectedThread[0].receiverInfo.hash_id)">
              <img *ngIf="myProfileHash == selectedThread[0].senderInfo.hash_id" [src]="selectedThread[0].receiverInfo.imgThumbUrl" onerror="this.src='../../../../assets/images/user-avatar.svg'" style="height: 40px; width: 40px; border-radius: 50%;     object-fit: cover;" alt="">
              <img *ngIf="myProfileHash == selectedThread[0].receiverInfo.hash_id" [src]="selectedThread[0].senderInfo.imgThumbUrl" onerror="this.src='../../../../assets/images/user-avatar.svg'" style="height: 40px; width: 40px; border-radius: 50%;     object-fit: cover;" alt="">
  
            </span>
            <span *ngIf="myProfileHash == selectedThread[0].senderInfo.hash_id && myProfileHash == selectedThread[0].receiverInfo.hash_id">
              <img [src]="selectedThread[0].senderInfo.imgThumbUrl" onerror="this.src='../../../../assets/images/user-avatar.svg'" style="height: 40px; width: 40px; border-radius: 50%;     object-fit: cover;" alt="">
            </span>
            <span style="    display: flex
            ;
                margin-top: -20px;
                margin-left: 45px;
            " *ngIf="(myProfileHash == selectedThread[0].senderInfo.hash_id && myProfileHash != selectedThread[0].receiverInfo.hash_id) || (myProfileHash != selectedThread[0].senderInfo.hash_id && myProfileHash == selectedThread[0].receiverInfo.hash_id)">
  
              <span style="margin-left: 10px;position: relative;top: -10px;font-weight: 700;font-size: 16px;"*ngIf="myProfileHash == selectedThread[0].senderInfo.hash_id"> {{ selectedThread[0].receiverInfo.name }}</span>
              <span style="margin-left: 10px;position: relative;top: -10px;font-weight: 700;font-size: 16px;"*ngIf="myProfileHash == selectedThread[0].receiverInfo.hash_id"> {{ selectedThread[0].senderInfo.name }}</span>
            </span>
            <span style="    display: flex
            ;
                margin-top: -20px;
                margin-left: 45px;
            " *ngIf="myProfileHash == selectedThread[0].senderInfo.hash_id && myProfileHash == selectedThread[0].receiverInfo.hash_id">
              <span style="margin-left: 10px;position: relative;top: -10px;font-weight: 700;font-size: 16px;"*ngIf="myProfileHash == selectedThread[0].receiverInfo.hash_id"> {{ selectedThread[0].senderInfo.name }}</span>
            </span>


              <button mat-icon-button mat-dialog-close style="position:absolute;top: 10px;right: 0px;">
                <mat-icon>close</mat-icon>
              </button>
              <button mat-icon-button style="position:absolute;top: 10px;right: 35px;" (click)="refresh()">
                <mat-icon>refresh</mat-icon>
              </button>
          </div>
          <div class="bns_pliud_aas" >
            <div class="asde" >
                <div class="scrollbox hrklm" id="divExample" #scrollableDiv>
                    <div class="chat-history scrollbox-content" >
                        <ul >
                            <li class="clearfix" *ngFor="let message of selectedThread; let i=index;">
                                
                                <div class="bgmes_thy" *ngIf="message.iSent == 1">
                                    <div class="message other-message float-right" style="position: relative;" [ngClass]="{'custcls': message.status != 1}">
                                      <button
                                      *ngIf="message.status == 1"
                                      style="top: -6px;
                                      right: 0px;
                                      position: absolute;"
                                      mat-icon-button
                                      [matMenuTriggerFor]="menuopt"
                                      class="profile_button"
                                      class="opt"
                                    >
                                      <mat-icon class="material-icons-outlined" style="font-size: 20px; color: #585858;"
                                        >more_horiz</mat-icon
                                      >
                                    </button>
                                    <mat-menu #menuopt="matMenu">
                  
                                      <button mat-menu-item (click)="deleteMessage(message.subMsgHash)">
                                        <!-- <mat-icon class="material-icons-outlined"
                                          ></mat-icon
                                        > -->
                                        <span class="menu_text">Delete</span>
                                      </button>
                                    </mat-menu>
                                        <div class="myDIV" [ngStyle]="{'margin-top': message.status == 1 ? '8px' : '0px'}">
                                         
                                            <p *ngIf="message.status == 1" class="bnstextspace">{{message.message}}</p>
                                            <p *ngIf="message.status != 1" class="bnstextspace">This message was deleted</p>
    
                                           
                                        </div>
                                          <!--  message timestamp here -->
                                          <div style="    text-align: right;
                                          font-size: 12px;
                                          color: #121212;
                                          padding: 10px 0px 0px 10px;
                                      ">
                                            <span>{{message.creationTime | date:'dd-MM-yyyy, h:mm a':'UTC+0530'}}</span>
                                          </div>
                                    </div>
                                </div>
                                <div class="bgnon_thy" *ngIf="message.iSent == 0">
                                    <div class="message my-message float-left" [ngClass]="{'custcls2': message.status != 1}">
                                        
                                        <div class="myDIV">
                                            <p *ngIf="message.status == 1" class="bnstextspace">{{message.message}}</p>
                                            <p *ngIf="message.status != 1" class="bnstextspace">This message was deleted</p>
    
                                        </div>
                                          <!--  message timestamp here -->
                                          <div style="    text-align: right;
                                          font-size: 12px;
                                          color: #121212;
                                          padding: 10px 0px 0px 10px;
                                      ">
                                            <span>{{message.creationTime | date:'dd-MM-yyyy, h:mm a':'UTC+0530'}}</span>
                                          </div>
                                    </div>
                                </div>
                            </li>
                            <div class="sd_mgr"></div>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="chat_cnp_ter">
                <div class="row" style="background: #fff; padding: 0; margin: 0; ">
                    <div class="col-sm-10" style=" padding: 0;
                    margin: 0;">
                        <div class="text_area-chat">
                            <textarea (keydown.enter)="sendMessage()" placeholder="Write something" class="textarealol" name="message" style="resize: none;" [(ngModel)]="message" [disabled]="textAreaDisabled"></textarea>
                        </div>
                    </div>
                    <div class="col-sm-2" style=" padding: 0;
                    margin: 0;" (click)="sendMessage()">
                        <div class="wlm_tmn_icn" *ngIf="!textAreaDisabled">
                            <ul>
                                <a href="javascript:void(0)">
                                    <li class="plne oplrea"  id="send-message"><mat-icon style=" color: #fff;
                                      position: relative;
                                      top: 5px;
                                      left: 2px;" >send</mat-icon></li>
                                </a>
                            </ul>
                        </div>
                        <div class="wlm_tmn_icn" *ngIf="textAreaDisabled">
                            <ul>
                                <a href="javascript:void(0)">
                                    <li class="plne2 oplrea"  id="send-message"><mat-spinner [diameter]="30" style="position: relative;
                                      left: 10px;
                                      top: 2px;  stroke: #fff;"></mat-spinner></li>
                                </a>
                            </ul>
                        </div>
                    </div>
                </div>
               
                
            </div>
        </div>
        </div>
        <!-- previously not chatted -->
        <div class="right-panel" *ngIf="selectedThread.length == 0 && !chatLoader">
            <div class="header">
             
              <img  [src]="parentData.employeeImage" onerror="this.src='../../../../assets/images/user-avatar.svg'" style="height: 50px; width: 50px; border-radius: 50%;" alt="">
              <span style="margin-left: 10px;" > {{parentData.title}}</span>
              <button mat-icon-button mat-dialog-close style="position:absolute;top: 10px;right: 0px;">
                <mat-icon>close</mat-icon>
              </button>
              <!-- <button mat-icon-button style="position:absolute;top: 10px;right: 35px;" (click)="refresh()">
                <mat-icon>refresh</mat-icon>
              </button> -->
            </div>
            <div class="bns_pliud_aas" >
              <div class="asde" >
                  <div class="scrollbox hrklm" id="divExample" #scrollableDiv>
                      <div class="chat-history scrollbox-content" >
                          <ul >
                              <li class="clearfix" *ngFor="let message of selectedThread; let i=index;">
                                  
                                  <div class="bgmes_thy" *ngIf="message.iSent == 1">
                                      <div class="message other-message float-right" >
                                          
                                          <div class="myDIV">
                                              <p  class="bnstextspace">{{message.message}}</p>
                                             
                                          </div>
                                         
                                      </div>
                                  </div>
                                  <div class="bgnon_thy" *ngIf="message.iSent == 0">
                                      <div class="message my-message float-left" >
                                          
                                          <div class="myDIV">
                                              <p class="bnstextspace">{{message.message}}</p>
      
                                          </div>
                                        
                                      </div>
                                  </div>
                              </li>
                              <div class="sd_mgr"></div>
                          </ul>
                      </div>
                  </div>
              </div>
              <div class="chat_cnp_ter">
                  <div class="row" style="    background: #fff;
                  padding: 0;
                  margin: 0;
              ">
                      <div class="col-sm-10" style=" padding: 0;
                      margin: 0;">
                          <div class="text_area-chat">
                              <textarea (keydown.enter)="sendMessage()" placeholder="Write something" class="textarealol" name="message" style="resize: none;" [(ngModel)]="message" [disabled]="textAreaDisabled"></textarea>
                          </div>
                      </div>
                      <div class="col-sm-2" style=" padding: 0;
                      margin: 0;" (click)="sendMessage()">
                          <div class="wlm_tmn_icn" *ngIf="!textAreaDisabled">
                              <ul>
                                  <a href="javascript:void(0)">
                                      <li class="plne oplrea"  id="send-message"><mat-icon style=" color: #fff;
                                        position: relative;
                                        top: 5px;
                                        left: 2px;" >send</mat-icon></li>
                                  </a>
                              </ul>
                          </div>
                          <div class="wlm_tmn_icn" *ngIf="textAreaDisabled">
                              <ul>
                                  <a href="javascript:void(0)">
                                      <li class="plne2 oplrea"  id="send-message"><mat-spinner [diameter]="30" style="position: relative;
                                        left: 10px;
                                        top: 2px;  stroke: #fff;"></mat-spinner></li>
                                  </a>
                              </ul>
                          </div>
                      </div>
                  </div>
                 
                  
              </div>
          </div>
          </div>
    
          <!-- chat loader animation -->
        <div class="right-panel" *ngIf="chatLoader">
          <div class="bns_pliud_aas">
            <div class="asde" style="background: #eee;">
                <div class="" style="    overflow-y: auto;
                visibility: hidden;
                height: 617px;
                overflow-x: hidden;" id="divExample" >
                    <div class="chat-history scrollbox-content">
                      <div style="padding: 200px 100px 100px;
                      text-align: center;">
                      <svg version="1.1" id="L4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve" style=" width: 130px;
                      height: 130px;
                      margin: 20px;
                      display:inline-block;">
                      <circle fill="#FFC107" stroke="none" cx="6" cy="50" r="4">
                        <animate
                          attributeName="opacity"
                          dur="1s"
                          values="0;1;0"
                          repeatCount="indefinite"
                          begin="0.1"/>    
                      </circle>
                      <circle fill="#FFC107" stroke="none" cx="26" cy="50" r="4">
                        <animate
                          attributeName="opacity"
                          dur="1s"
                          values="0;1;0"
                          repeatCount="indefinite" 
                          begin="0.2"/>       
                      </circle>
                      <circle fill="#FFC107" stroke="none" cx="46" cy="50" r="4">
                        <animate
                          attributeName="opacity"
                          dur="1s"
                          values="0;1;0"
                          repeatCount="indefinite" 
                          begin="0.3"/>     
                      </circle>
                      <circle fill="#FFC107" stroke="none" cx="66" cy="50" r="4">
                        <animate
                          attributeName="opacity"
                          dur="1s"
                          values="0;1;0"
                          repeatCount="indefinite" 
                          begin="0.3"/>     
                      </circle>
                      <circle fill="#FFC107" stroke="none" cx="86" cy="50" r="4">
                        <animate
                          attributeName="opacity"
                          dur="1s"
                          values="0;1;0"
                          repeatCount="indefinite" 
                          begin="0.3"/>     
                      </circle>
                    </svg>
                        <!-- <h3 style="margin-top: 20px; color: #7c7c7c; font-size: 1.5rem;">Please select a thread from the left to begin chatting.</h3> -->
                      </div>
                    </div>
                </div>
            </div>
          </div>            
        </div>
      </div>
  </mat-dialog-content>
 

  
  
  
  
  
  